import classnames from 'classnames/bind';
import Linkifier from './lib/linkifier';
import PropTypes from 'prop-types';
import React from 'react';

import overrideStyle from 'lib/overrideStyle';
import { Communicators } from 'presentation/components/lib/communicators';
import styles from 'presentation/components/styles/Message.css';
let cx = classnames.bind(styles);

export default function Message(props) {
  const messagePropTypes = {
    sender: PropTypes.string.isRequired,
    content: PropTypes.string.isRequired,
  };
  PropTypes.checkPropTypes(messagePropTypes, props, 'prop', 'Message');

  let classes = cx('message', props.className, {
    message_agent: props.sender === Communicators.AGENT,
    message_customer: props.sender === Communicators.CUSTOMER,
  });

  let linkClasses = cx({
    chatLink_customAgentColors: props.sender === Communicators.AGENT,
    chatLink_customCustomerColors: props.sender === Communicators.CUSTOMER,
  });

  return (
    <OuterWrapper tabIndex="0" sender={props.sender}>
      <InnerWrapper
        className={classes}
        data-aid={getDataAid(props.sender)}
        tabIndex="-1"
        onClick={() => true}
        onKeyDown={() => true}
      >
        <Linkifier className={styles.message_linkify} linkClassName={linkClasses} tagName="div">
          {props.content}
        </Linkifier>
      </InnerWrapper>
    </OuterWrapper>
  );
}

function getDataAid(sender) {
  switch (sender) {
    case Communicators.AGENT:
      return 'gladlyChatAgentMessage';
    case Communicators.CUSTOMER:
      return 'gladlyChatCustomerMessage';
    default:
      return 'gladlyChatWelcomeMessage';
  }
}

const OuterWrapper = overrideStyle('div')`
  align-self: ${p => (p.sender === Communicators.CUSTOMER ? 'flex-end' : 'flex-start')};
  flex: 0 0 auto;
  margin: 1px 15px;
`;

const InnerWrapper = overrideStyle('div')`
  box-shadow: none;
  outline: none;
`;
